import { AssetRequestType, AssetResolver, AssetResolverContext } from "@/core/asset-resolver"
import type { Renderer } from "@/core/pipeline/renderer"

export class HealingAiResolver extends AssetResolver {
	public get type(): AssetRequestType {
		return "healing-ai" as AssetRequestType
	}

	public async resolve(cacheId: string, context: AssetResolverContext) {
		console.info(`[healing-ai-resolver] Resolving healing AI source`, cacheId)

		const photo = context.photo

		// Extract base healing ID from cache ID format: ${healing.id}_v${variation}_a${align}_b${brush}
		const baseId = cacheId.split("___v")[0]
		const healing = photo.adjustments.healingMasks?.find((h) => h.id === baseId)

		if (!healing || !healing.aiVariations || healing.aiVariations.length === 0) {
			console.warn(
				`[healing-ai-resolver] Cannot find healing or no AI variations for`,
				cacheId,
			)
			return
		}

		// Load the specific variation with current settings
		// The actual textures are managed by healingRenderer.hydrateAiSources
		// It will generate the same cache ID internally and load only if not cached
		await context.renderer.healingPass.healingRenderer.hydrateAiSources([healing])

		// Mark as resolved in the asset manager using the cache ID
		// Store a simple status flag - the actual texture data lives in healingRenderer.aiSources
		context.renderer.assets.setArtefact({ type: this.type, id: cacheId }, true)
	}

	public cleanup(renderer?: Renderer) {
		// Only cleanup AI sources, other resources like textures are managed by healing-pass
		if (renderer) {
			renderer.healingPass.healingRenderer.removeAllAiSources()
		}
	}
}
